import { combineReducers } from 'redux';
// Import reducers
import table from './payments_panel_reducer';

export default combineReducers({
	table
});
